// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { reviewAndPlaceOrderStyles } from "@conklin/Overrides/Widgets/OnePageCheckout/OnePageCheckoutReviewAndPlaceOrder";
import { css } from "styled-components";

reviewAndPlaceOrderStyles.placeOrderButton = {
    sizeVariant: "large",
    css: css`
        width: 100%;
    `,
};

reviewAndPlaceOrderStyles.submitForApprovalButton = {
    sizeVariant: "large",
    css: css`
        width: 100%;
    `,
};

reviewAndPlaceOrderStyles.placeOrderErrorMessageText = {
    css: css`
        margin-top: 12px;
        margin-bottom: 8px;
        &:last-of-type {
            margin-bottom: 0;
        }
    `,
};
